export default __webpack_public_path__ + "static/img/remoterack.f713ceb.png";